import { gql } from '@apollo/client';

export const VERIFY_TOKEN = gql`
  mutation($input: VerifyInput!) {
    verifyToken(input: $input) {
      payload
    }
  }
`;
